import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BiSolidError } from 'react-icons/bi';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <Flex height={'100vh'} justify={'center'} align={'center'}>
      <Flex gap={'30px'}>
        <Heading fontSize={'100px'} className='text-primary'>
          404
        </Heading>
        <Flex flexDir={'column'} justify={'center'}>
          <Text
            display={'flex'}
            alignItems={'center'}
            gap={'5pxpx'}
            fontSize={'20px'}
          >
            <BiSolidError color={'#f70112'} size={20} />
            Oops! Page not found.
          </Text>
          <Text>The page you are looking for was not found.</Text>

          <Button
            mt='10px'
            borderColor={'#f70112'}
            color={'#f70112'}
            variant={'outline'}
            onClick={() => navigate('/')}
          >
            Go to Home
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default PageNotFound;
